enum WorkspaceProjectMetricMeasurementFrequency {
  'Year(s)' = 'Year(s)',
  'Month(s)' = 'Month(s)',
  'Week(s)' = 'Week(s)',
  'Day(s)' = 'Day(s)',
}

export default WorkspaceProjectMetricMeasurementFrequency
